export const huggingfaceModels = {
    id: "huggingface",
    name: "Hugging Face",
    api: "https://router.huggingface.co/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://huggingface.co/docs/inference-providers",
    env: ["HF_TOKEN"],
    models: {
        "deepseek-ai/Deepseek-V3-0324": {
            id: "deepseek-ai/Deepseek-V3-0324",
            name: "DeepSeek-V3-0324",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-03-24",
            last_updated: "2025-03-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.25,
                output: 1.25,
            },
            limit: {
                context: 16384,
                output: 8192,
            },
        },
        "deepseek-ai/DeepSeek-R1-0528": {
            id: "deepseek-ai/DeepSeek-R1-0528",
            name: "DeepSeek-R1-0528",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-28",
            last_updated: "2025-05-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 3,
                output: 5,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "Qwen/Qwen3-Coder-480B-A35B-Instruct": {
            id: "Qwen/Qwen3-Coder-480B-A35B-Instruct",
            name: "Qwen3-Coder-480B-A35B-Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 2,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "Qwen/Qwen3-235B-A22B-Thinking-2507": {
            id: "Qwen/Qwen3-235B-A22B-Thinking-2507",
            name: "Qwen3-235B-A22B-Thinking-2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 3,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "zai-org/GLM-4.5-Air": {
            id: "zai-org/GLM-4.5-Air",
            name: "GLM-4.5-Air",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 1.1,
            },
            limit: {
                context: 128000,
                output: 96000,
            },
        },
        "zai-org/GLM-4.5": {
            id: "zai-org/GLM-4.5",
            name: "GLM-4.5",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.2,
            },
            limit: {
                context: 131072,
                output: 98304,
            },
        },
        "moonshotai/Kimi-K2-Instruct": {
            id: "moonshotai/Kimi-K2-Instruct",
            name: "Kimi-K2-Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-14",
            last_updated: "2025-07-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 3,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
    },
};
export default huggingfaceModels;
//# sourceMappingURL=huggingface.js.map